export default "__VITE_ASSET__DxS6vVmB__"